<p class="text-danger"><ng-content></ng-content></p>